import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/scss/style.css';

//Components
import TextHeadingThree from '../atoms/TextHeadingThree';
import FormToggleSwitch from '../atoms/FormToggleSwitch';
import FormLabel from '../atoms/FormLabel';
import Icon from '../atoms/Icon';


//Returning the component
class BotBox extends Component {
	render() {
		return (
			<div className="botBox">
				<Link className="botBox__name" to={this.props.href}>
					<TextHeadingThree text={this.props.TextHeadingThree} />
				</Link>
				<FormLabel for={this.props.labelFor} text={this.props.labelText} id={this.props.labelId} />
				<FormToggleSwitch active={this.props.checked} onChange={this.props.onChange} />
				<div className="botBox__option">
				<Icon role="button" classType="icon--button fa-trash fa-lg " onClick={this.props.onClickDelete}/>
				<Icon role="button" classType="icon--button fa-pencil fa-lg" onClick={this.props.onClickUpdate}/>
				</div>
			</div>
		)
	}
}

export default BotBox;


// WEBPACK FOOTER //
// ./src/redux/components/molecules/BotBox.jsx